import {ToMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';
import {EmptyString, StringUnion} from 'Core/models/EmptyString';

export class InvalidPolicyNumber {
  public readonly key = 'InvalidPolicyNumber';

  constructor(public readonly value: StringUnion) {}
}

export class ValidPolicyNumber {
  public static create(value: StringUnion) {
    return new ValidPolicyNumber(value);
  }

  public readonly key = 'ValidPolicyNumber';
  constructor(public readonly value: StringUnion) {}
}

export type PolicyNumber = ValidPolicyNumber | InvalidPolicyNumber;
export type PolicyNumberOptions<TReturn> = ToMatchOptions<PolicyNumber, 'key', TReturn>;

export const matchPolicyNumber = <TReturn>(
  policyNumber: PolicyNumber,
  options: PolicyNumberOptions<TReturn>
): TReturn => {
  switch (policyNumber.key) {
    case 'InvalidPolicyNumber':
      return options.InvalidPolicyNumber(policyNumber);
    case 'ValidPolicyNumber':
      return options.ValidPolicyNumber(policyNumber);
  }
};

const PolicyNumberRegEx = /^[PM]([0-9]{6})$/;
const ExtPolicyNumberRegEx = /^([0-9]{2})[PM]([0-9]{6})([0-9A-Z]{1})$/;

const ElectonicPolicyNumberRegEx = /^[^PM]([0-9A-Z]{1}[0-9]{5})$/;
const ExtElectonicPolicyNumberRegEx = /^([0-9]{2})[^PM]([0-9A-Z]{1}[0-9]{5})([0-9A-Z]{1})$/;

export const isValidPolicyNumber = (policyNumber: PolicyNumber): policyNumber is ValidPolicyNumber =>
  policyNumber.key === 'ValidPolicyNumber' &&
  (PolicyNumberRegEx.test(policyNumber.value.value) || ExtPolicyNumberRegEx.test(policyNumber.value.value));

export const isValidElectronicPolicyNumber = (policyNumber: PolicyNumber): policyNumber is ValidPolicyNumber =>
  policyNumber.key === 'ValidPolicyNumber' &&
  (ElectonicPolicyNumberRegEx.test(policyNumber.value.value) ||
    ExtElectonicPolicyNumberRegEx.test(policyNumber.value.value));

export const isValidPolicyNumberPaperElectronic = (policyNumber: PolicyNumber): policyNumber is ValidPolicyNumber =>
  isValidPolicyNumber(policyNumber) || isValidElectronicPolicyNumber(policyNumber);

export const EmptyPolicyNumber = new InvalidPolicyNumber(new EmptyString());
